// extracted by css-extract-rspack-plugin
export default {"profileImageContainer":"tIVzUIYV","loading":"kXyu0tzq","loader":"FrPlc_1M","medium":"SLDmhH3u","webcamContainer":"BbbpJB6z","image":"XiqupUnS","buttonContainer":"TLUhiRMx"};